<template>
  <nx-fullscreen-dialog
      :active="active"
      :title="$t('message.block.blockquote')"
      @dismiss="dismiss">

    <template slot="toolbar-items">
      <v-btn
          color="accent"
          flat
          :disabled="!isValid"
          @click="insertBlot"
          v-html="buttonTitle"
      ></v-btn>
    </template>

    <v-container pb-3 fluid>
      <v-layout>
        <v-flex class="md6 offset-md3 sm10 offset-sm1 pt-4">
          <v-layout row wrap>
            <v-flex class="xs12">

              <h2 class="nx-block-headline">{{ formTitle }}</h2>

              <v-select
                  :items="items"
                  :label="$t('message.block.form.select')"
                  item-value="type"
                  v-model="data.type"
              ></v-select>

              <v-textarea
                  :counter="blockquoteLimit"
                  :label="$t('message.block.form.blockquote')"
                  :rules="blockquoteRule"
                  autofocus
                  v-model="data.blockquote"
              ></v-textarea>

              <template v-if="hasAuthor">
                <v-text-field
                    :label="$t('message.block.form.author')"
                    v-model="data.author"
                ></v-text-field>

                <v-text-field
                    :label="$t('message.block.form.role')"
                    v-model="data.role"
                ></v-text-field>
              </template>

            </v-flex>
          </v-layout>

        </v-flex>
      </v-layout>
    </v-container>

  </nx-fullscreen-dialog>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import DialogButton from './DialogButton';

/**
 * BlockquoteButton Component
 *
 * Extend DialogButton component
 *
 */

export default {
  name: 'nx-blockquote-button',
  extends: DialogButton,
  props: {
    embedType: {
      type: String,
      default: 'simple',
    },
    embedBlockquote: String,
    embedAuthor: String,
    embedRole: String,
    embedFull: String,
  },
  data() {
    return {
      name: 'blockquoteEmbed',
      data: {
        type: this.embedType || '',
        blockquote: this.embedBlockquote || '',
        author: this.embedAuthor || '',
        role: this.embedRole || '',
        // embedFull se recupera del dataset del elemento
        // donde se almacena como string y no como bool
        full: this.embedFull === 'true',
      },
      items: [
        { text: this.$t('message.block.form.option.textual'), type: 'simple' },
        { text: this.$t('message.block.form.option.author'), type: 'author' },
      ],
      blockquoteLimit: 1000,
    };
  },
  computed: {
    blockquoteRule() {
      return [
        v => v.length <= this.blockquoteLimit || this.$t('message.block.form.blockquoteLimit'),
      ];
    },
    isValid() {
      if (isEmpty(this.data.blockquote)
        || this.data.blockquote.length > this.blockquoteLimit
        || (this.hasAuthor && isEmpty(this.data.author.trim()))) {
        return false;
      }
      return true;
    },
    hasAuthor() {
      return this.data.type === 'author';
    },
  },
};
</script>
